import { forwardRef } from "react";
import * as React from "react";
import cn from "classnames";

import "./button.scss";

export type ButtonStyle =
  | "default"
  | "solid"
  | "link"
  | "flat-icon"
  | "text"
  | "primary"
  | "passive"
  | "highlighted"
  | "inline"
  | "pill";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  disabled?: boolean;
  styleType?: ButtonStyle;
  type?: "button" | "submit" | "reset";
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      disabled = false,
      className = "",
      styleType = "default",
      type = "button",
      ...rest
    }: ButtonProps,
    forwardedRef,
  ) => (
    <button
      ref={forwardedRef}
      data-auto="button"
      className={cn("eb-button", `eb-button--${styleType}`, className)}
      disabled={disabled}
      type={type}
      {...rest}
    />
  ),
);

Button.displayName = "Button";

export default Button;
